<template>
  <svg
    class="custom-icon"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.551 17.3807C12.551 17.2189 12.4429 17.0787 12.2882 17.0355C9.40464 16.2264 7.35627 13.6412 7.20161 10.6746L8.87228 10.6746C9.0127 10.6746 9.13865 10.5918 9.19982 10.466C9.25738 10.3402 9.23945 10.1927 9.1495 10.0848L5.14249 6.12942C5.07409 6.05027 4.9733 6 4.86888 6C4.76086 6 4.66006 6.05042 4.59166 6.12942L0.250295 10.0848C0.16035 10.1927 0.142269 10.34 0.199823 10.466C0.260991 10.5918 0.386949 10.6746 0.527367 10.6746L2.5 10.6746C2.68728 14.7521 6.07119 18.0136 10.2001 18.0136C10.9057 18.0136 11.6076 17.9166 12.288 17.726C12.4429 17.6827 12.551 17.5426 12.551 17.3807Z"
    />
    <path
      d="M5.5665 0.793955C5.5665 0.95573 5.67453 1.09599 5.82926 1.13918C8.71267 1.94821 10.7612 4.53344 10.9159 7.50007L9.24457 7.50007C9.10416 7.50007 8.9782 7.57923 8.91703 7.70504C8.85948 7.83446 8.87741 7.98194 8.9675 8.08984L12.9751 12.0452C13.0435 12.1244 13.1443 12.171 13.2487 12.171C13.3568 12.171 13.4576 12.1242 13.526 12.0416L17.917 8.09008C17.971 8.02537 17.9999 7.9426 17.9999 7.85998C17.9999 7.80957 17.9891 7.75569 17.9675 7.70543C17.9063 7.57962 17.7804 7.50046 17.64 7.50046L15.6176 7.50046C15.4305 3.41949 12.0466 0.157941 7.91751 0.157941C7.21195 0.157942 6.51002 0.255007 5.82961 0.449138C5.67458 0.49218 5.5665 0.632028 5.5665 0.793955Z"
    />
  </svg>
</template>
